<template>
  <div v-if="car" class="page">
    <h5 class="my-2">Найдено {{ car.activeFines.length }} активных из {{ car.fines.length }} штрафов</h5>
    <div v-for="fine in car.fines" :key="fine.id" class="mobile-table-view card mt-4 mb-2 p-2">
      <table class="table borderless">
        <tbody>
          <tr>
            <td style="border-top: none" />
            <td style="border-top: none">
              <StatusState class="float-right" :archived_at="fine.archived_at" />
            </td>
          </tr>
          <tr>
            <td style="border-top: none">Причина</td>
            <td style="border-top: none">{{ fine.cause }}</td>
          </tr>
          <tr>
            <td>Сумма</td>
            <td>{{ fine.amount }}</td>
          </tr>
          <tr>
            <td>Номер постановления</td>
            <td>{{ fine.num_post }}</td>
          </tr>
          <tr>
            <td>Дата</td>
            <td>{{ fine.date }}</td>
          </tr>
          <tr v-if="fine.date_discount">
            <td>Дата окончания скидки</td>
            <td>{{ fine.date_discount }}</td>
          </tr>
          <tr v-if="fine.driver_id">
            <td>Водитель</td>
            <td>
              <router-link :to="'/drivers/' + fine.driver_id">
                {{ getDriver(fine.driver) }}
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { djsMixin } from '@/mixins/djsMixin'
import FinesAPI from '../api/fines'
import StatusState from '../components/StatusState'

export default {
  name: 'FinesCarShow',
  components: {StatusState},
  mixins: [djsMixin],
  props: {
    carId: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      car: null
    }
  },
  computed: {
    getDriver () {
      return (driver) => {
        if (!driver) {
          return ''
        }
        return driver.last_name + ' ' + driver.first_name + ' ' + driver.middle_name
      }
    }
  },
  mounted () {
    this.loadData()
  },
  beforeDestroy () {
    this.abortLoading()
  },
  methods: {
    ...mapActions('fines/fines', [
      'abortLoading'
    ]),
    loadData () {
      FinesAPI.getItem({
        id: this.carId,
        queryWith: ['fines', 'activeFines']
      })
        .then(response => {
          this.car = response
          if (!response) {
            return false
          }
          this.car.fines.sort((fine) => (fine.archived_at) ? 1 : -1)
          this.$emit('load-car', response)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-top: 1rem;
  height: 100%;
  overflow-y: auto;
}
@media screen and (max-width: 1199px) {
  .page {
    padding: 1rem;
  }
}
@media screen and (max-width: 576px) {
  .page {
    padding: 0.5rem;
  }
}
</style>
